import { render, staticRenderFns } from "./EmployeeNotification.vue?vue&type=template&id=391289a8&scoped=true"
import script from "./EmployeeNotification.vue?vue&type=script&lang=js"
export * from "./EmployeeNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391289a8",
  null
  
)

export default component.exports